import { GALLERY_PRICING_URL } from "@/data/urls";
import { getCustomAuthToken } from "@/utils/getCustomAuthToken";
import { getAuth } from "firebase/auth";

export const getGalleryPricingUrl = async (): Promise<string> => {
  try {
    const idToken = await getAuth().currentUser?.getIdToken();
    const customToken = idToken ? await getCustomAuthToken(idToken) : null;

    if (!customToken) return GALLERY_PRICING_URL;

    const url = new URL(GALLERY_PRICING_URL);
    url.searchParams.set("token", customToken);

    return url.toString();
  } catch (error) {
    console.error("[Gallery pricing URL] Token exchange failed.", error);
    return GALLERY_PRICING_URL;
  }
};
